/* eslint-disable */
import React, { useContext, useState } from 'react';
import { Grid, Paper, Button, Typography } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import {
  backLabelStyle,
  btnStyle,
  btnStyleActive,
  forgotHeaderStyle,
  h2Style,
  labelStyle,
  paperStyle,
  pLabelDarkerStyle,
  pLabelStyle,
} from '../styles';
import { AuthContext } from '../../contexts/authContext';
import { AuthPAGES } from '../../constants/pages';
import { forgotPStyle } from '../forgot-password/styles';
import ReactCodeInput from 'react-code-input';
import { useValidCode } from '../../hooks/useValidCode';
import { PAGES } from '../../../../types/pages';
import { Notif } from '../../components/Snackbar/Snackbar';

type styleProps = {
  top?: string;
  position?: string;
};

const VerifyPhone: React.FC<styleProps> = (props) => {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);
  const [genericErrorMessage, setGenericErrorMessage] = useState('');
  const { code, setCode, codeIsValid } = useValidCode('');
  const [open, setOpen] = React.useState(false);
  const { phone, email } = authContext;

  const onReSendCode = async () => {
    // if (phone) await authContext.onConfirmCodeResendCodePhone(phone, email);
  };

  const sendCode = async (e: any) => {
    e.stopPropagation();
    if (code && code.length > 0 && code.length <= 6) {
      if (phone) {
        try {
          navigate(AuthPAGES.signIn);
          await authContext.onConfirmCodeSubmittedPhone(code, phone, email);
        } catch (e: any) {
          setGenericErrorMessage(e.message);
        }
      } else
        try {
          // await authContext.onConfirmCodeSubmitted(code, email, email);
          // navigate(AuthPAGES.signIn);
          await authContext.sendMfaCode(email, code);
          navigate(PAGES.landing);
          window.location.reload();
        } catch (error: any) {
          setGenericErrorMessage(error.message);
          setOpen(true);
        }
    }
  };

  const isButtonDisabled = () => {
    return codeIsValid !== '';
  };

  return (
    <Grid
      container
      justifyContent='center'
      alignContent='center'
      style={{
        display: 'flex',
        flexDirection: 'column',
        top: props.top ? props.top : '',
        position: props.position ? (props.position as any) : undefined,
      }}
    >
      <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
        <Paper elevation={0} style={paperStyle}>
          <Grid item xs={12} md={12} xl={12} style={forgotHeaderStyle}>
            <h2 style={h2Style}>Verification by SMS</h2>
            <p style={forgotPStyle}>
              We have sent on your phone: 22 05 3*** an SMS with a verification
              code.Please enter the code
            </p>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
          >
            <ReactCodeInput
              type='text'
              fields={6}
              name='anyName'
              inputMode='tel'
              onChange={(e: any) => setCode(e)}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={labelStyle}>
            <Typography>
              <Link
                to=''
                onClick={(e) => onReSendCode}
                style={pLabelDarkerStyle}
              >
                Send Code Again
              </Link>
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} xl={12}>
            <Button
              type='submit'
              color='primary'
              variant='contained'
              style={isButtonDisabled() ? btnStyle : btnStyleActive}
              fullWidth
              onClick={(e: any) => {
                sendCode(e);
              }}
              disabled={isButtonDisabled()}
            >
              Submit
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ ...backLabelStyle, marginTop: '48px' }}
          >
            <Link style={pLabelStyle} to='' onClick={(e: any) => navigate(-1)}>
              Back
            </Link>
          </Grid>
        </Paper>
      </Grid>
      <Notif open={open} setOpen={setOpen} message={genericErrorMessage} />
    </Grid>
  );
};

export default VerifyPhone;
